import dottie from 'dottie'
import { api } from '@/api'

/**
 * Amazon Pay subscription flow (via Stripe)
 *
 * start() fetches a SetupIntent client secret, the caller redirects via
 * stripe.confirmAmazonPaySetup(); checkout data survives the redirect
 * in sessionStorage and the return view finalizes via checkout/finishSepa
 */

const STORAGE_KEY = 'amazonpayCheckout'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async start(context, { itemId, buyerId, customAmount, afterSaleAnswer }) {
    const response = await api.post('/initialize-amazonpay', {
      itemId,
      buyerId,
      customAmount,
      afterSaleAnswer
    })
    return dottie.get(response, 'data.clientSecret', null)
  },

  persistCheckoutData(context, data) {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  },

  restoreCheckoutData() {
    try {
      const data = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY))
      window.sessionStorage.removeItem(STORAGE_KEY)
      return data
    } catch (e) {
      return null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
